module.exports = __webpack_public_path__ + "img/img3.a05856d1.png";